export const UserStamps = [
  'cat',
  'dog',
  'bear',
  'lion',
  'tiger',
  'panda',
  'rabbit',
  'elephant',
  'chicken',
  'penguin',
  'fish',
  'octopus',
  'frog',
  'butterfly',
  'dinosaur',
  'robot',
  'goast',
  'tulip',
  'pudding',
  'donut',
  'tomato',
  'riceball',
  'icecream',
  'soccer',
  'car',
  'ship',
  'balloon_ride',
  'rocket',
  'sun',
  'moon',
  'rainbow',
  'fuji',
  'heart',
  'balloon',
  'rose',
  'sunflower',
];
